import React from "react"
import { JobStatus, JobType } from "../../../../../Models/API/JobModel"
import { JobStatusPill } from "../../Sections/AppDetail/Common/JobStatusPill"
import { Text } from "dash-styled"
import { fromNow } from "../../../../../Helpers/Functions/dateFormat"
import styles from "./DataPointVersionListItem.module.css"

interface DataPointVersionListItemProps {
    created: Date | null
    correct: boolean | null
    status: JobStatus
    jobType: JobType
    version: string
}

export const DataPointVersionListItem: React.FC<DataPointVersionListItemProps> =
    ({
        created,
        correct,
        status,
        version,
        jobType
    }: DataPointVersionListItemProps) => {
        const job = {
            correct,
            status,
            jobType
        }

        const timeDifferenceLabel =
            created === null ? "" : fromNow(created.toString())

        return (
            <div className="flex w-full">
                <Text
                    color="darkgray"
                    component="div"
                    size="sm"
                    className={`flex-grow ${styles.ListItemText}`}
                >
                    {version}
                </Text>
                <Text
                    color="darkgray"
                    component="div"
                    size="xs"
                    className={`flex-grow-0 ml-16 opacity-60 pt-0.5 ${styles.ListItemText}`}
                >
                    {timeDifferenceLabel}
                </Text>
                <JobStatusPill
                    job={job}
                    size="sm"
                    className="ml-2 flex-grow-0"
                ></JobStatusPill>
            </div>
        )
    }
